import { render, staticRenderFns } from "./DottedSpinner.vue?vue&type=template&id=b8f5c69c&scoped=true&"
import script from "./DottedSpinner.vue?vue&type=script&lang=js&"
export * from "./DottedSpinner.vue?vue&type=script&lang=js&"
import style0 from "./DottedSpinner.vue?vue&type=style&index=0&id=b8f5c69c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f5c69c",
  null
  
)

export default component.exports